<template>
  <div class="room ventilation" v-loading="loadingData">
    <RefreshBlock @refreshData="refreshData"></RefreshBlock>
    <div class="device-block-multi">
      <div class="air-wrap" :class="warningFlagTopLeft">
        <div class="air-title">{{ this.stationName }}温湿度</div>
        <div class="air-chart-wrap">
          <SinglePieHistogramWrap
            class="device-block-multi-item"
            :opts="singlePieHistogramWrapOptsTopLeft1"
            :series="singlePieHistogramWrapDataTopLeft1"
            :class="singlePieHistogramWarningFlagTopLeft1"
          ></SinglePieHistogramWrap>
          <SinglePieHistogramWrap
            class="device-block-multi-item"
            :opts="singlePieHistogramWrapOptsTopLeft2"
            :series="singlePieHistogramWrapDataTopLeft2"
            :class="singlePieHistogramWarningFlagTopLeft2"
          ></SinglePieHistogramWrap>
        </div>
      </div>

      <div class="air-wrap" :class="warningFlagTopRight">
        <div class="air-title">{{ this.stationName }}温湿度</div>
        <div class="air-chart-wrap">
          <SinglePieHistogramWrap
            class="device-block-multi-item"
            :opts="singlePieHistogramWrapOptsTopRight1"
            :series="singlePieHistogramWrapDataTopRight1"
            :class="singlePieHistogramWarningFlagTopRight1"
          ></SinglePieHistogramWrap>
          <SinglePieHistogramWrap
            class="device-block-multi-item"
            :opts="singlePieHistogramWrapOptsTopRight2"
            :series="singlePieHistogramWrapDataTopRight2"
            :class="singlePieHistogramWarningFlagTopRight2"
          ></SinglePieHistogramWrap>
        </div>
      </div>
    </div>

    <div class="device-block-line">
      <div class="air-wrap" :class="warningFlagBottomLeft">
        <div class="air-title">{{ this.stationName }}温湿度</div>
        <div class="air-chart-wrap">
          <SinglePieHistogramWrap
            class="device-block-multi-item"
            :opts="singlePieHistogramWrapOptsBottomLeft1"
            :series="singlePieHistogramWrapDataBottomLeft1"
            :class="singlePieHistogramWarningFlagBottomLeft1"
          ></SinglePieHistogramWrap>
          <SinglePieHistogramWrap
            class="device-block-multi-item"
            :opts="singlePieHistogramWrapOptsBottomLeft2"
            :series="singlePieHistogramWrapDataBottomLeft2"
            :class="singlePieHistogramWarningFlagBottomLeft2"
          ></SinglePieHistogramWrap>
        </div>
      </div>

      <div class="device-block-line-item">
        <div class="device-block-line-item-top">
          <div class="device-block-line-item-half">
            <SwitchStatus class="switch-item" :title="switchTitleL1" :series="switchDataL1"></SwitchStatus>
            <SwitchStatus class="switch-item" :title="switchTitleL2" :series="switchDataL2"></SwitchStatus>
            <SwitchStatus class="switch-item" :title="switchTitleL3" :series="switchDataL3"></SwitchStatus>
            <SwitchStatus class="switch-item" :title="switchTitleL4" :series="switchDataL4"></SwitchStatus>
            <SwitchStatus class="switch-item" :title="switchTitleL5" :series="switchDataL5"></SwitchStatus>
            <SwitchStatus class="switch-item" :title="switchTitleL6" :series="switchDataL6"></SwitchStatus>
          </div>
          <div class="device-block-line-item-half">
            <SwitchStatus class="switch-item" :title="switchTitleR1" :series="switchDataR1"></SwitchStatus>
            <SwitchStatus class="switch-item" :title="switchTitleR2" :series="switchDataR2"></SwitchStatus>
            <SwitchStatus class="switch-item" :title="switchTitleR3" :series="switchDataR3"></SwitchStatus>
            <SwitchStatus class="switch-item" :title="switchTitleR4" :series="switchDataR4"></SwitchStatus>
            <SwitchStatus class="switch-item" :title="switchTitleR5" :series="switchDataR5"></SwitchStatus>
            <SwitchStatus class="switch-item" :title="switchTitleR6" :series="switchDataR6"></SwitchStatus>
          </div>
        </div>
        <div class="device-block-line-item-bottom">
          <div class="device-block-line-item-half">
            <RunningTime class="divice-block-thin" :title="runningTimeTitleL1" :series="runningTimeDataL1" :isHour="true"></RunningTime>
            <RunningTime class="divice-block-thin" :title="runningTimeTitleL2" :series="runningTimeDataL2" :isHour="true"></RunningTime>
          </div>
          <div class="device-block-line-item-half">
            <RunningTime class="divice-block-thin" :title="runningTimeTitleR1" :series="runningTimeDataR1" :isHour="true"></RunningTime>
            <RunningTime class="divice-block-thin" :title="runningTimeTitleR2" :series="runningTimeDataR2" :isHour="true"></RunningTime>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import configJson from "./config/steelBox.json";

export default {
  name: "ventilationNew",
  data() {
    return {
      timer: null,
      loading: false,
      loadingData: false,
      stationId: "",
      stationName: "",
      deviceList: [],

      areaName1: "",
      areaName2: "",
      areaName3: "",

      fanAreaName1: "",
      fanAreaName2: "",

      // switchTitleL1: "1-2区送风机启动",
      // switchTitleL2: "1-2区送风机运行",
      // switchTitleL3: "1-2区回风机运行",
      // switchTitleL4: "3区送风机启动",
      // switchTitleL5: "3区送风机运行",
      // switchTitleL6: "3区回风机运行",
      // switchTitleR1: "1-2区回风机启动",
      // switchTitleR2: "1-2区送风机故障",
      // switchTitleR3: "1-2区回风机故障",
      // switchTitleR4: "3区回风机启动",
      // switchTitleR5: "3区送风机故障",
      // switchTitleR6: "3区回风机故障",
      // runningTimeTitleL1: "1-2区送风机运行时间",
      // runningTimeTitleL2: "1-2区回风机运行时间",
      // runningTimeTitleR1: "3区送风机运行时间",
      // runningTimeTitleR2: "3区回风机运行时间",

      singlePieHistogramWrapDataTopLeft1: {},
      singlePieHistogramWrapDataTopLeft2: {},
      singlePieHistogramWrapDataTopRight1: {},
      singlePieHistogramWrapDataTopRight2: {},
      singlePieHistogramWrapDataBottomLeft1: {},
      singlePieHistogramWrapDataBottomLeft2: {},

      switchDataL1: {},
      switchDataL2: {},
      switchDataL3: {},
      switchDataL4: {},
      switchDataL5: {},
      switchDataL6: {},
      switchDataR1: {},
      switchDataR2: {},
      switchDataR3: {},
      switchDataR4: {},
      switchDataR5: {},
      switchDataR6: {},

      runningTimeDataL1: null,
      runningTimeDataL2: null,
      runningTimeDataR1: null,
      runningTimeDataR2: null,

      warningFlagTopLeft: "",
      warningFlagTopRight: "",
      warningFlagBottomLeft: "",

      singlePieHistogramWarningFlagTopLeft1: "",
      singlePieHistogramWarningFlagTopLeft2: "",
      singlePieHistogramWarningFlagTopRight1: "",
      singlePieHistogramWarningFlagTopRight2: "",
      singlePieHistogramWarningFlagBottomLeft1: "",
      singlePieHistogramWarningFlagBottomLeft2: "",

      humidityLineData: null,
      humidityBarData: null,
    };
  },
  computed: {
    switchTitleL1: function () {
      return this.fanAreaName1 + "送风机启动";
    },
    switchTitleL2: function () {
      return this.fanAreaName1 + "送风机运行";
    },
    switchTitleL3: function () {
      return this.fanAreaName1 + "回风机运行";
    },
    switchTitleL4: function () {
      return this.fanAreaName2 + "送风机启动";
    },
    switchTitleL5: function () {
      return this.fanAreaName2 + "送风机运行";
    },
    switchTitleL6: function () {
      return this.fanAreaName2 + "回风机运行";
    },
    switchTitleR1: function () {
      return this.fanAreaName1 + "回风机启动";
    },
    switchTitleR2: function () {
      return this.fanAreaName1 + "送风机故障";
    },
    switchTitleR3: function () {
      return this.fanAreaName1 + "回风机故障";
    },
    switchTitleR4: function () {
      return this.fanAreaName2 + "回风机启动";
    },
    switchTitleR5: function () {
      return this.fanAreaName2 + "送风机故障";
    },
    switchTitleR6: function () {
      return this.fanAreaName2 + "回风机故障";
    },
    runningTimeTitleL1: function () {
      return this.fanAreaName1 + "送风机运行时间";
    },
    runningTimeTitleL2: function () {
      return this.fanAreaName1 + "回风机运行时间";
    },
    runningTimeTitleR1: function () {
      return this.fanAreaName2 + "送风机运行时间";
    },
    runningTimeTitleR2: function () {
      return this.fanAreaName2 + "回风机运行时间";
    },
    singlePieHistogramWrapOptsTopLeft1: function () {
      return {
        title: this.areaName1 + "温湿度1",
        histogramName1: "T",
        center1: ["52%", "60%"],
        radius1: ["40%", "55%"],
        pieName1: "RH",
        max: 50,
        pieMax: 100,
        toprichFontSize: 18,
        topFontSize: 20,
        sign: "°C",
      };
    },
    singlePieHistogramWrapOptsTopLeft2: function () {
      return {
        title: this.areaName1 + "温湿度2",
        histogramName1: "T",
        center1: ["52%", "60%"],
        radius1: ["40%", "55%"],
        pieName1: "RH",
        max: 50,
        pieMax: 100,
        toprichFontSize: 18,
        topFontSize: 20,
        sign: "°C",
      };
    },

    singlePieHistogramWrapOptsTopRight1: function () {
      return {
        title: this.areaName2 + "温湿度1",
        histogramName1: "T",
        center1: ["52%", "60%"],
        radius1: ["40%", "55%"],
        pieName1: "RH",
        max: 50,
        pieMax: 100,
        toprichFontSize: 18,
        topFontSize: 20,
        sign: "°C",
      };
    },
    singlePieHistogramWrapOptsTopRight2: function () {
      return {
        title: this.areaName2 + "温湿度2",
        histogramName1: "T",
        center1: ["52%", "60%"],
        radius1: ["40%", "55%"],
        pieName1: "RH",
        max: 50,
        pieMax: 100,
        toprichFontSize: 18,
        topFontSize: 20,
        sign: "°C",
      };
    },

    singlePieHistogramWrapOptsBottomLeft1: function () {
      return {
        title: this.areaName3 + "温湿度1",
        histogramName1: "T",
        center1: ["52%", "60%"],
        radius1: ["40%", "55%"],
        pieName1: "RH",
        max: 50,
        pieMax: 100,
        toprichFontSize: 18,
        topFontSize: 20,
        sign: "°C",
      };
    },
    singlePieHistogramWrapOptsBottomLeft2: function () {
      return {
        title: this.areaName3 + "温湿度2",
        histogramName1: "T",
        center1: ["52%", "60%"],
        radius1: ["40%", "55%"],
        pieName1: "RH",
        max: 50,
        pieMax: 100,
        toprichFontSize: 18,
        topFontSize: 20,
        sign: "°C",
      };
    },
  },
  created() {
    this.readConfig();
  },
  mounted() {
    this.getData();
    this.timer = setInterval(() => {
      this.getData();
    }, this.REFRESH_SECOND);
  },
  watch: {
    /**
     * 监听路由变化
     * @param {Object} route # 当前路由信息
     */
    $route(route) {
      this.resetData();
      this.readConfig();
      this.loadingData = true;
      this.getData();
    },
  },
  methods: {
    readConfig() {
      const routerPath = this.$route.fullPath.split("/");
      this.deviceList = configJson[routerPath[3]].deviceList;
      // const deviceName = configJson[routerPath[3]].deviceName;
      // this.deviceLeftName = deviceName.deviceLeftName;
      // this.deviceRightName = deviceName.deviceRightName;
      this.stationId = configJson[routerPath[3]].stationId;
      this.stationName = configJson[routerPath[3]].stationName;
      this.bridgeSegmentName = configJson[routerPath[3]].bridgeSegmentName;

      this.areaName1 = configJson[routerPath[3]].areaName1;
      this.areaName2 = configJson[routerPath[3]].areaName2;
      this.areaName3 = configJson[routerPath[3]].areaName3;

      this.fanAreaName1 = configJson[routerPath[3]].fanAreaName1;
      this.fanAreaName2 = configJson[routerPath[3]].fanAreaName2;
    },
    resetData() {
      this.warningFlagTopLeft = "";
      this.warningFlagTopRight = "";
      this.warningFlagBottomLeft = "";
    },
    refreshData() {
      this.loadingData = true;
      this.getData();
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.getData();
      }, this.REFRESH_SECOND);
    },
    findDeviceId(deviceName) {
      const device = this.deviceList.find((el) => {
        return el.deviceName === deviceName;
      });
      if (!device) {
        console.log(`deviceName${deviceName}###`);
      }
      return device.deviceId || "";
    },
    getCurrentData(stationId) {
      return this.$http.get(`/deviceData/Station?stationId=${stationId}`);
    },
    getData() {
      let request = this.getCurrentData(this.stationId);
      request.then((res) => {
        setTimeout(() => {
          this.loadingData = false;
        }, 500);
        let currentData = res.data;

        this.setPieHistogramDataAndError(
          currentData,
          "singlePieHistogramWrapDataTopLeft1",
          this.areaName1 + "温度1",
          this.areaName1 + "湿度1",
          "singlePieHistogramWarningFlagTopLeft1"
        );
        this.setPieHistogramDataAndError(
          currentData,
          "singlePieHistogramWrapDataTopLeft2",
          this.areaName1 + "温度2",
          this.areaName1 + "湿度2",
          "singlePieHistogramWarningFlagTopLeft2"
        );

        this.setPieHistogramDataAndError(
          currentData,
          "singlePieHistogramWrapDataTopRight1",
          this.areaName2 + "温度1",
          this.areaName2 + "湿度1",
          "singlePieHistogramWarningFlagTopRight1"
        );
        this.setPieHistogramDataAndError(
          currentData,
          "singlePieHistogramWrapDataTopRight2",
          this.areaName2 + "温度2",
          this.areaName2 + "湿度2",
          "singlePieHistogramWarningFlagTopRight2"
        );

        this.setPieHistogramDataAndError(
          currentData,
          "singlePieHistogramWrapDataBottomLeft1",
          this.areaName3 + "温度1",
          this.areaName3 + "湿度1",
          "singlePieHistogramWarningFlagBottomLeft1"
        );
        this.setPieHistogramDataAndError(
          currentData,
          "singlePieHistogramWrapDataBottomLeft2",
          this.areaName3 + "温度2",
          this.areaName3 + "湿度2",
          "singlePieHistogramWarningFlagBottomLeft2"
        );

        const switchIdL1 = this.findDeviceId(this.switchTitleL1);
        const switchIdL2 = this.findDeviceId(this.switchTitleL2);
        const switchIdL3 = this.findDeviceId(this.switchTitleL3);
        const switchIdL4 = this.findDeviceId(this.switchTitleL4);
        const switchIdL5 = this.findDeviceId(this.switchTitleL5);
        const switchIdL6 = this.findDeviceId(this.switchTitleL6);
        const switchIdR1 = this.findDeviceId(this.switchTitleR1);
        const switchIdR2 = this.findDeviceId(this.switchTitleR2);
        const switchIdR3 = this.findDeviceId(this.switchTitleR3);
        const switchIdR4 = this.findDeviceId(this.switchTitleR4);
        const switchIdR5 = this.findDeviceId(this.switchTitleR5);
        const switchIdR6 = this.findDeviceId(this.switchTitleR6);
        this.switchDataL1 = {
          data: currentData[switchIdL1].value,
          isError: currentData[switchIdL1].errorLevel,
        };
        this.switchDataL2 = {
          data: currentData[switchIdL2].value,
          isError: currentData[switchIdL2].errorLevel,
        };
        this.switchDataL3 = {
          data: currentData[switchIdL3].value,
          isError: currentData[switchIdL3].errorLevel,
        };
        this.switchDataL4 = {
          data: currentData[switchIdL4].value,
          isError: currentData[switchIdL4].errorLevel,
        };
        this.switchDataL5 = {
          data: currentData[switchIdL5].value,
          isError: currentData[switchIdL5].errorLevel,
        };
        this.switchDataL6 = {
          data: currentData[switchIdL6].value,
          isError: currentData[switchIdL6].errorLevel,
        };
        this.switchDataR1 = {
          data: currentData[switchIdR1].value,
          isError: currentData[switchIdR1].errorLevel,
        };
        this.switchDataR2 = {
          data: currentData[switchIdR2].value,
          isError: currentData[switchIdR2].errorLevel,
          isZh: true,
        };
        this.switchDataR3 = {
          data: currentData[switchIdR3].value,
          isError: currentData[switchIdR3].errorLevel,
          isZh: true,
        };
        this.switchDataR4 = {
          data: currentData[switchIdR4].value,
          isError: currentData[switchIdR4].errorLevel,
        };
        this.switchDataR5 = {
          data: currentData[switchIdR5].value,
          isError: currentData[switchIdR5].errorLevel,
          isZh: true,
        };
        this.switchDataR6 = {
          data: currentData[switchIdR6].value,
          isError: currentData[switchIdR6].errorLevel,
          isZh: true,
        };

        const runningTimeIdL1 = this.findDeviceId(this.runningTimeTitleL1);
        const runningTimeIdL2 = this.findDeviceId(this.runningTimeTitleL2);
        const runningTimeIdR1 = this.findDeviceId(this.runningTimeTitleR1);
        const runningTimeIdR2 = this.findDeviceId(this.runningTimeTitleR2);
        this.runningTimeDataL1 = currentData[runningTimeIdL1].value;
        this.runningTimeDataL2 = currentData[runningTimeIdL2].value;
        this.runningTimeDataR1 = currentData[runningTimeIdR1].value;
        this.runningTimeDataR2 = currentData[runningTimeIdR2].value;

        console.log(this.runningTimeDataL1 + " " + this.runningTimeDataL2);
      });
    },

    setPieHistogramDataAndError(currentData, echartSeriesDataName, temperatureName, humidityName, warningFlagName) {
      const temperatureId = this.findDeviceId(temperatureName);
      const humidityId = this.findDeviceId(humidityName);
      this[echartSeriesDataName] = {
        data1: currentData[temperatureId].value,
        data2: currentData[humidityId].value,
      };

      let errorLevel = this.getErrorLevelFromMultipleDevice(currentData[temperatureId].errorLevel, this[warningFlagName]);
      errorLevel = this.getErrorLevelFromMultipleDevice(currentData[humidityId].errorLevel, this[warningFlagName]);
      this[warningFlagName] = errorLevel;
    },

    setLineData(temperatureData, humidityData, echartSeriesDataName, warningFlagName) {
      let data1 = {};
      let data2 = {};
      temperatureData.data.dataList.forEach((item, index) => {
        data1[item.StatisticsDate] = item.value;
      });
      humidityData.data.dataList.forEach((item, index) => {
        data2[item.StatisticsDate] = item.value;
      });

      this[echartSeriesDataName] = {
        data1: data1,
        data2: data2,
      };

      let errorLevel = this.getErrorLevelFromMultipleDevice(temperatureData.data.errorLevel, this[warningFlagName]);
      errorLevel = this.getErrorLevelFromMultipleDevice(humidityData.data.errorLevel, this[warningFlagName]);
      this[warningFlagName] = errorLevel;
    },

    getErrorLevelFromMultipleDevice(newErrorLevel, currentErrorLevel) {
      if (currentErrorLevel === "Error") {
        return "Error";
      } else if (currentErrorLevel === "Warning") {
        if (newErrorLevel === "Error") {
          return "Error";
        } else {
          return "Warning";
        }
      } else {
        return newErrorLevel;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.ventilation {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: stretch;
  align-content: stretch;
  padding-top: 10px;

  .device-block-multi {
    width: 100%;
    height: calc(50% - 15px);
    background-color: transparent;
    display: flex;
    justify-content: space-between;
    align-items: stretch;

    .device-block {
      width: calc(50% - 10px);
      height: 100%;
      display: flex;
      justify-content: space-between;
      align-items: stretch;
      position: relative;

      .device-block-line-chart {
        width: 75%;
        height: 100%;
      }

      .device-block-bar-chart {
        width: 24%;
        height: 100%;
      }
    }
  }

  .device-block-line {
    width: 100%;
    height: calc(50% - 15px);
    background-color: transparent;
    display: flex;
    justify-content: space-between;
    align-items: stretch;

    .device-block-line-item {
      width: calc(50% - 9px);
      display: flex;
      box-sizing: border-box;
      justify-content: space-between;
      flex-direction: column;
      align-items: stretch;

      .device-block-line-item-half {
        display: flex;
        height: 100%;
        width: calc(50% - 7px);
        flex-direction: column;
        justify-content: space-between;
      }

      .device-block-line-item-top {
        display: flex;
        justify-content: space-between;
        height: 60px;
        width: 100%;
      }

      .device-block-line-item-bottom {
        display: flex;
        justify-content: space-between;
        height: calc(100% - 290px);
        width: 100%;
      }

      .switch-item {
        height: 38px;
        width: 100%;
        box-sizing: border-box;
        flex-shrink: 0;
        margin-bottom: 10px;
        &:last-child {
          margin-bottom: 0;
        }
      }

      .divice-block-thin {
        height: calc(50% - 5px);
        width: 100%;
        box-sizing: border-box;
        flex-shrink: 0;
        margin-bottom: 10px;
        &:last-child {
          margin-bottom: 0;
        }
      }

      .running-time-item {
        height: calc(100% - 110px);
        width: 100%;
        box-sizing: border-box;
      }

      &.single-chart-item {
        background-color: rgba(255, 255, 255, 0.6);
      }
    }
  }

  .air-wrap {
    box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.2);
    display: flex;
    flex-direction: column;
    padding: 0 10px;
    width: calc(50% - 10px);
    height: 100%;
    background-color: rgba(255, 255, 255, 0.6);
    box-sizing: border-box;

    .air-title {
      padding: 20px 15px 10px 10px;
      font-size: 22px;
      color: #515151;
    }

    .air-chart-wrap {
      height: 80%;
      display: flex;
      flex: 1;
    }

    // .air-chart-wrap {
    //   width: calc(50% - 10px);
    //   height: 100%;
    //   display: flex;
    //   flex: 1;
    //   justify-content: space-between;
    //   align-items: stretch;
    //   position: relative;
    // }

    .air-chart {
      padding: 20px 0;
      box-sizing: border-box;
      width: 33.3333%;

      .device-block-multi-item {
        width: calc((100% / 3) - 10px);
        height: 100%;
        background-color: rgba(255, 255, 255, 0.6);
      }
    }
  }
}
</style>
